import AthenaRoutes from "@routes/Athena";
import CernerRoutes from "@routes/Cerner";
import { ContextDetails } from "ehr-launcher-lib";
import AscensionHeader from "@components/AscensionHeader";
import ThemeProvider from "@components/ThemeProvider";
import { styled } from "@stitches/react";

const RoutesWrapper = styled("div", {});

const RouteResolver = ({ ehr }: { ehr: ContextDetails["currentEHR"] }) => {
  const RouteMapper = {
    athena: AthenaRoutes,
    cerner: CernerRoutes,
  };

  return (
    <RoutesWrapper className="routes-wrapper" data-testid="routes-wrapper">
      <ThemeProvider ehr={ehr}>
        <AscensionHeader text="Acute Auth Connect" ehr={ehr} />
        {RouteMapper[ehr]()}
      </ThemeProvider>
    </RoutesWrapper>
  );
};

export default RouteResolver;
